<template>
  <div class="mine page">
    <div class="page-bg"></div>
    <div class="wrapper">
      <van-pull-refresh :pulling-text="$t('reservation.refresh')" :loosing-text="$t('reservation.refreshpage')"
        :loading-text="$t('reservation.refresh')" :success-text="$t('reservation.refresh')" v-model="isLoading"
        @refresh="onRefresh">
        <div class="header">
          <div class="top">
            <div class="font renzheng" @click="goInfomation()">
              <img src="../../assets/bc-img/set.png" alt="">
            </div>
            <div class="font renzheng" @click="showSetting()">
              <img src="../../assets/bc-img/friend.png" alt="">
            </div>
          </div>
          <div class="user-wrapper" @click="doLogin()">
            <div class="login-content m-flex">
              <van-image class="userpic" round src="/img/mine/userpic.png">
                <template v-slot:loading>
                  <van-loading type="spinner" />
                </template>
              </van-image>
              <div class="info">
                <p class="login-btn ps22 m-f1 m-flex m-f-between">
                  {{ this.userInfo.username }}
                  <!-- <span v-if="vip_info.vip == 0">
                    {{ 
                      vip_info.vip != 0
                        ? $t("Certified")
                        : $t("Unauthenticated")
                    }}
                  </span>
                  <span v-else-if="vip_info.vip < 0">{{ $t("Frozen") }}</span> -->
                </p>
              </div>
            </div>
          </div>
          <div class="stats-container">
            <div class="stat-card vip-card">
              <div class="stat-title">
                <img src="../../assets/bc-img/vip.png" alt="">
              </div>
              <div class="stat-value" style="color: #BD8A49;">VIP {{ this.userInfo.vip }}</div>
            </div>
            <div class="stat-card xy-card">
              <div class="stat-title">
                <img src="../../assets/bc-img/xy.png" alt="">
              </div>
              <div class="stat-value" style="color: #BE7554;">{{ this.userInfo.score}}{{$t('my.score')}}</div>
            </div>
            <div class="stat-card balance-card">
              <div class="stat-title">
                <img src="../../assets/bc-img/money.png" alt="">
              </div>
              <div class="stat-value" style="color: #09D7E2;">{{ this.userInfo.money }}{{ $t("reservation.unit") }}</div>
            </div>
          </div>
        </div>
        <div class="content">
          <!-- <div class="bc-hot">
            <div class="hot-title">{{ $t("my.Account_Center") }}</div>
            <div>{{ $t("my.personal_center") }}</div>
          </div> -->
          <!-- <div class="finance">
						<div class="finance-item" @click="toService()">
							<van-icon class="icon" style="" name="peer-pay" />
							<span class="text">{{$t("my.recharge")}}</span>
						</div>
						<div class="line"></div>
						<div class="finance-item" @click="doWithdrawal()">
							<van-icon class="icon" name="idcard" />
							<span class="text">{{$t("my.withdraw")}}</span>
						</div>
					</div> -->
          <!-- <div class="finance">
						<div class="finance-item">
							<span class="font-28 font-gray">{{ $t('my.balance') }}（{{ $t('reservation.unit') }}）</span>
							<p class="balance van-ellipsis">{{ parseInt(userInfo.money) || 0 }}</p>
						</div>
						<div class="finance-item">
							<span class="font-28 font-gray">{{ $t('my.score') }}</span>
							<p class="balance van-ellipsis">{{ userInfo.score || 0 }}</p>
						</div>
					</div> -->

          <!-- <div v-if="this.userInfo.money" class="wallet">
						<div class="part-1 van-hairline--bottom">
							<p class="flex-1 font-28 font-primary-color">{{$t("my.my_balance")}}</p>
							<span class="font-28 font-gray">{{$t("my.detail")}}</span>
							<van-icon class="font-gray" style="font-size: 28px" name="arrow" />
						</div>
						<div class="part-2">
							<p class="balance van-ellipsis">{{this.userInfo.money}}</p>
							<span class="font-28 font-gray">{{$t('my.balance')}}</span>
							<div class="refresh-btn" @click="refresh()"><van-icon name="replay" /></div>
						</div>
						<div class="part-2">
							<p class="balance van-ellipsis">{{this.userInfo.score}}</p>
							<span class="font-28 font-gray">{{$t('my.score')}}</span>
							<div class="refresh-btn" @click="refresh()"><van-icon name="replay" /></div>
						</div>

					</div> -->
          <div class="menu">
            <!-- 信息 -->
            <!-- <div
              class="menu-item"
              @click="$router.push({ path: '/Infomation' })"
            >
              <img
                src="../../assets/bc-img/9.png"
                class="menu-item-icon"
                alt=""
              />
              <span class="menu-item-label">{{
                $t("my.personal_center")
              }}</span>
            </div> -->
            <!-- 登录密码 -->
            <div class="menu-item" @click="Login_password()">
              <!-- <van-icon class="menu-item-icon" style="" name="peer-pay" /> -->
              <img src="../../assets/bc-img/12.png" class="menu-item-icon" alt="" />
              <span class="menu-item-label">{{ $t("my.Login_password") }}</span>
            </div>
            <!-- 投注记录 -->
            <div class="menu-item" @click="$router.push({ path: '/GameRecord' })">
              <!-- <van-image class="menu-item-icon" src="img/mine/youxi.svg">
                <template v-slot:loading>
                  <van-loading type="spinner" />
                </template>
              </van-image> -->
              <img src="../../assets/bc-img/6.png" class="menu-item-icon" alt="" />
              <span class="menu-item-label">{{ $t("my.task_record") }}</span>
            </div>
            <!-- 充值 -->
            <!-- <div class="menu-item" @click="payment()">
              <van-icon class="menu-item-icon" style="" name="peer-pay" />
              <img
                src="../../assets/bc-img/1.png"
                class="menu-item-icon"
                alt=""
              />
              <span class="menu-item-label">{{ $t("my.recharge") }}</span>
            </div> -->
            <!-- 银行账户提现 -->
            <div class="menu-item" @click="doWithdrawal()">
              <img src="../../assets/bc-img/1.png" class="menu-item-icon" alt="" />
              <span class="menu-item-label">{{ $t("my.withdraw1") }}</span>
            </div>
            <!-- 虚拟货币提现 -->
            <div class="menu-item" @click="doWithdrawal2()">
              <img src="../../assets/bc-img/3.png" class="menu-item-icon" alt="" />
              <span class="menu-item-label">{{ $t("my.withdraw2") }}</span>
            </div>
            <!-- 设置提现密码 -->
            <div class="menu-item" @click="$router.push({ path: '/SetPayPassword' })">
              <img src="../../assets/bc-img/9.png" class="menu-item-icon" alt="" />
              <span class="menu-item-label">{{ $t("my.my_statement") }}</span>
            </div>
            <!-- 提现记录 -->
            <div class="menu-item" @click="$router.push({ path: '/WithdrawRecord' })">
              <img src="../../assets/bc-img/11.png" class="menu-item-icon" alt="" />
              <span class="menu-item-label">{{ $t("my.account_detail") }}</span>
            </div>
            <!-- 语言选择 -->
            <div class="menu-item" @click="language()">
              <img src="../../assets/bc-img/8.png" class="menu-item-icon" alt="" />
              <span class="menu-item-label">{{ $t("setting.language") }}</span>
            </div>
            <!-- 平台规则 -->
            <div class="menu-item" @click="torules()">
              <img src="../../assets/bc-img/5.png" class="menu-item-icon" alt="" />
              <span class="menu-item-label">{{ $t("my.Platform_rules") }}</span>
            </div>
            <van-button class="sign-out" type="primary" size="normal" @click="loginout()">{{ $t("setting.logout")
              }}</van-button>
          </div>
        </div>
      </van-pull-refresh>
    </div>

    <div class="tip-wrap" v-if="tip_show">
      <div class="tip-content text-center" v-html="tip_text"></div>
      <div class="tip-btn" @click="
        tip_show = false;
      tip_text = '';
      ">
        {{ $t("setting.ok") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mine',
  data() {
    return {
      userInfo: {},
      menu_top: 40,
      isLoading: false,
      tip_text: "",
      tip_show: false,
      vip_info: {},
    };
  },
  methods: {
    applyCachedUserInfo() {
      const storeUserInfo = this.$store.getters.getUserInfo;
      if (storeUserInfo && Object.keys(storeUserInfo).length > 0) {
        this.userInfo = { ...storeUserInfo };
        this.vip_info = { ...storeUserInfo };
        return true;
      }
      const localUserInfo = localStorage.getItem("cached_user_info");
      if (localUserInfo) {
        try {
          const parsedUserInfo = JSON.parse(localUserInfo);
          if (parsedUserInfo && Object.keys(parsedUserInfo).length > 0) {
            this.userInfo = parsedUserInfo;
            this.vip_info = parsedUserInfo;
            return true;
          }
        } catch (error) { }
      }
      return false;
    },
    loginout() {
      localStorage.removeItem("cached_user_info");
      localStorage.clear();
      this.$router.push({ path: "/login" });
    },
    torules() {
      this.$router.push("/Torules");
    },

    language() {
      this.$router.push("/Language");
    },
    Login_password() {
      this.$router.push("/SetLoginPassword");
    },
    goInfomation() {
      this.$router.push("/Infomation");
    },
    payment() {
      this.tip_text = this.$t("Universal.personal");
      this.tip_show = true;
    },

    async refresh() {
      this.isLoading = true;
      if (!localStorage.getItem("token")) {
        this.$router.push({
          path: "/Login",
        });
        this.isLoading = false;
        return;
      }
      try {
        await this.getUserInfo();
        this.$toast(this.$t("reservation.refresh"));
      } finally {
        this.isLoading = false;
      }
    },
    exit() {
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      // if (localStorage.getItem("token")) {
      //   this.$router.push({
      //     path: "/ServiceOnline",
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/Login",
      //   });
      // }
      this.$toast(this.$t("Universal.personal"));
    },
    toNotice() {
      if (localStorage.getItem("token")) {
        this.$router.push({
          path: "/Notice",
        });
      } else {
        this.$router.push({
          path: "/Login",
        });
      }
    },
    async onRefresh() {
      if (!localStorage.getItem("token")) {
        this.$router.push({
          path: "/Login",
        });
        this.isLoading = false;
        return;
      }
      try {
        await this.getUserInfo();
        this.$toast(this.$t("reservation.refresh"));
      } finally {
        this.isLoading = false;
      }
    },
    doLogin() {
      if (localStorage.getItem("token")) {
        this.$router.push({
          path: "/Infomation",
        });
      } else {
        this.$router.push({
          path: "/Login",
        });
      }
    },
    doPay() {
      this.$router.push({
        name: "Recharge",
        params: {
          balance: this.userInfo.money,
        },
      });
    },
    doWithdrawal() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        const is_bank = res.data.is_bank;
        if (is_bank) {
          this.$router.push({
            path: "withdraw",
            query: {
              bankinfo: res.data.info.bankinfo,
              bankid: res.data.info.bankid,
              branch_name: res.data.info.branch_name,
              bank_code: res.data.info.bank_code,
              username: res.data.info.username,
            },
          });
        } else {
          this.$router.push("Setbank");
          this.$toast.fail(this.$t("setting.set_bank"));
        }
      });
    },
    doWithdrawal2() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        console.log('获取到的虚拟银行信息',res.data);
        if (res.data.crypto.is_bind == true) {
          this.$router.push("Trc20");
        } else {
          this.$router.push("Settrc");
          this.$toast.fail(this.$t("setting.set_bank"));
        }
      });
    },
    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("ServiceOnline");
      } else {
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    getUserInfo() {
      return this.$http({
        method: "get",
        url: "user_info",
        data: {
          type: 1,
        },
      }).then((res) => {
        if (res.code === 200) {
          console.log('用户信息',res.data);
          this.userInfo = res.data;
          this.vip_info = res.data;
          this.$store.commit("setUserInfoValue", res.data);
          localStorage.setItem("cached_user_info", JSON.stringify(res.data));

          this.menu_top = 15;
          /* if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear()
            this.$router.push({
              path: '/Login'
            })
          } */
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        return res;
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      this.applyCachedUserInfo();
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/base.less";

.renzheng {
  img {
    width: 2.5vh;
  }
}

.sign-out {
  margin: 1em 20px 0;
  height: 60px;
  line-height: 100px;
  border-radius: 50px;
  color: @black;
  font-size: 20px;
  font-weight: bolder;
  border: none;
  background: #ffb169;
  width: 100%;
}

.bc-hot {
  color: #fff;
  font-size: 1.2rem;
  padding: 0 1rem 0rem 0.5rem;
  margin-bottom: 1.5rem;
}

.hot-title {
  color: #8c835f;
  font-weight: lighter !important;
  font-size: 0.7rem;
}

.stats-container {
  display: flex;
  justify-content: space-between;
  padding: 1rem 0rem 0 0rem;
  margin: 2.5rem 0 0 0;
}

.stat-card {
  width: 32%;
  padding: 0.5rem 0;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  img {
    width: 5vh;
  }
}

.balance-card {
  // background-color: #1a1a1a;
  border: 1px solid #444;
  background-image: url(../../assets/bc-img/moneybgi.png);
  background-size: 100% 100%;
}

.vip-card {
  // background-color: #1a1a1a;
  background-image: url(../../assets/bc-img/vipimg.png);
  background-size: 100% 100%;
  border: 1px solid #444;
}

.xy-card {
  // background-color: #1a1a1a;
  background-image: url(../../assets/bc-img/xyimg.png);
  background-size: 100% 100%;
  border: 1px solid #444;
}

.stat-title {
  color: #feb974;
  font-weight: lighter !important;
  font-size: 0.8rem;
  // margin-bottom: 0.5rem;
}

.stat-value {
  color: #fff;
  font-size: 0.8rem;
  font-weight: lighter !important;
}

.info {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 0.5rem;

  .VIP {
    color: #fff;
    font-size: 0.6rem;
    font-weight: lighter !important;
  }

  .money {
    margin: 0.5rem 0;
    font-weight: bolder !important;
    height: 2.5vh;
  }
}

.font {
  // color: #ffc57d;
  font-weight: lighter !important;
  font-size: 0.6rem;
  // background-color: rgba(255, 255, 255, 0.1);
  padding: 0.2rem 0.6rem;
  border-radius: 2rem;
  // border: 1px solid #4b4b4b;
  width: auto;
  margin-left: 0.4rem;
  display: flex;
  align-items: center;
  height: 3vh;
}

.vip {
  margin: @md1;
  color: @theme2;

  .vip-text {
    position: absolute;
    left: 10%;
  }

  p {
    margin: 0;
  }
}

.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
}

.mine {
  position: relative;
  bottom: 10px;
  background: linear-gradient(#1A1A1A, #000000);
}

.mine .wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0.5rem;
}

.mine .header {
  // background: linear-gradient(to right bottom, #473728, #0b0b0d);
  // padding-bottom: 100px;
  // border-radius: 1rem;
  // border: 1px solid #444;
  padding: 0.4rem 0.4rem;

  ::v-deep .van-icon {
    color: #fff !important;
    font-weight: lighter !important;
    font-size: 1.6rem;
  }

  .top {
    display: flex;
    justify-content: right;
    align-content: center;
  }
}

::v-deep .van-nav-bar__content {
  height: 100px;
  background: none !important;
}

::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0px;
}

.mine .header .van-nav-bar .van-icon {
  font-size: 45px;
}

.mine .header .user-wrapper {
  display: flex;
  align-items: center;
  // margin: 0px 40px 0px 40px;
  padding: 0 0.5rem 0 0.5rem;
}

.mine .user_img {
  height: 130px;
  width: 130px;
}

::v-deep .van-loading__spinner {
  height: 50px;
  width: 50px;
}

::v-deep .van-image__error-icon {
  font-size: 70px;
}

.mine .header .user-wrapper .login-content {
  flex: 1;
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1.5rem;

  .userpic {
    @userpic: 150px;
    // margin-right: @md1;
    width: @userpic;
    height: @userpic;
  }
}

.mine .header .user-wrapper .login-content .login-btn {
  font-weight: lighter !important;
  font-size: 36px;
  line-height: 0px;
  color: #fff;

  span {
    color: red;
    margin-left: 1rem;
  }
}

.mine .header .user-wrapper .login-content .login-label {
  font-size: 28px;
  color: @black;
}

.mine .page-bg {
  height: 500px;
}

.mine .content {
  // position: relative;
  padding-bottom: 10rem;
  min-height: 500px;
  margin-top: 0.8rem;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #ffffff;
  font-size: 35px;
}

.mine .wrapper .content .finance {
  display: flex;
  align-items: center;
  margin: 0 @md1;
  height: 120px;
  background-color: @theme1;
  border-radius: 15px;
  color: @theme2;
  transform: translateY(-50%);
}

.mine .wrapper .content .finance .line {
  width: 3px;
  height: 40px;
  background-color: #ccc;
}

.mine .wrapper .content .finance .finance-item {
  flex: 1;
  padding: 0.5em;
  height: 100%;
  text-align: center;
}

.mine .wrapper .content .finance .finance-item .text {
  margin-left: 30px;
  font-size: 30px;
  color: @white;
  font-weight: 500;
}

.mine .wrapper .content .finance .finance-item .icon {
  font-size: 50px;
  color: @theme2;
}

.mine .wrapper .content .menu {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 15px;
  // margin-top: 0em;
  // border-top: 2px solid #423c3e;
}

.mine .wrapper .content .menu .menu-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  color: @theme2;
  // border-bottom: 1px solid @theme2;

  &::after {
    content: "";
    display: inline-block;
    width: 0.5em;
    height: 0.5em;
    margin-left: auto;
    margin-right: @md1;
    border: 1px solid #fff;
    border-width: 1px 1px 0 0;
    transform: translateX(-50%) rotate(45deg);
  }
}

.mine .wrapper .content .menu .menu-item .menu-item-label {
  font-size: 25px;
  // font-weight: lighter !important;
  color: #fff;
}

.mine .wrapper .content .menu .menu-item .menu-item-icon {
  margin: 25px;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 70px;
  -o-object-fit: contain;
  object-fit: contain;
  color: @theme2;
  font-size: 50px;
}

.mine .wrapper .content .wallet {
  margin-top: 80px;
  padding: 0 30px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .wallet .part-1 {
  display: flex;
  align-items: center;
  height: 100px;
}

.mine .wrapper .content .wallet .font-primary-color {
  color: #000;
}

.font-gray {
  color: #868686;
}

.mine .wrapper .content .wallet .part-2 {
  display: flex;
  align-items: center;
  height: 150px;
}

.mine .wrapper .content .wallet .part-2 .balance {
  flex: 1;
  font-size: 60px;
  color: #f487e0;
  font-weight: 700;
}

.mine .wrapper .content .wallet .van-hairline--bottom::after {
  border-bottom-width: 3px;
}

.mine .wrapper .content .wallet .part-2 .refresh-btn {
  margin-left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  font-size: 30px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #e6c3a1;
}
</style>
